import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OwnershipType } from '../../../../dashboard/fleet/common/enums/ownership-type';
import type { Fleet } from '../../../../dashboard/fleet/common/interfaces/fleet';
import { AmountCellComponent } from '../amount-cell/amount-cell.component';

@Component({
  selector: 'app-vehicle-value-cell',
  imports: [AmountCellComponent, TranslatePipe],
  templateUrl: './vehicle-value-cell.component.html',
  styleUrl: './vehicle-value-cell.component.scss',
})
export class VehicleValueCellComponent {
  public readonly ownership = input.required<Fleet['ownership']>();

  protected readonly I18N = 'fleet.fleetList.cells';

  protected readonly OwnershipType = OwnershipType;
}
